"use client";

import type {
  FitnessScoreData,
  GoalImpactData,
} from "@/src/components/fitness/types";
import { GoalFitnessImpact } from "@/src/components/fitness/goal/GoalFitnessImpact";
import { cn } from "utils";

export interface GoalConfirmScoreImpactProps {
  impact: GoalImpactData | null | undefined;
  fitnessScore?: FitnessScoreData | null;
  showRadar?: boolean;
  className?: string;
}

/**
 * GoalConfirmScoreImpact — save_goal Activate 卡内分数影响区（Figma `98665:10807`）
 */
export function GoalConfirmScoreImpact({
  impact,
  fitnessScore = null,
  showRadar = false,
  className,
}: GoalConfirmScoreImpactProps) {
  if (!impact || impact.delta <= 0) {
    return null;
  }

  return (
    <GoalFitnessImpact
      impact={impact}
      fitnessScore={fitnessScore}
      showRadar={showRadar}
      hideTitle
      className={cn(className)}
      cardClassName="bg-background_brand_overlay10"
    />
  );
}
